import { motion, useReducedMotion } from 'motion/react';
import { House, Receipt, ChatCircleText, ClipboardText, Briefcase, FileText } from '@phosphor-icons/react';

const useCases = [
  { icon: House, label: 'Chasing your solicitor on a house purchase' },
  { icon: Receipt, label: 'Chasing an overdue invoice payment' },
  { icon: ChatCircleText, label: 'Following up on information you asked for' },
  { icon: ClipboardText, label: 'Chasing a quote for the work you need' },
  { icon: Briefcase, label: 'Following up on a job application' },
  { icon: FileText, label: 'Chasing a signed contract' },
];

function UseCaseCard({ item }) {
  const Icon = item.icon;
  return (
    <div className="flex flex-none items-center gap-3 whitespace-nowrap rounded-xl border border-white/10 bg-white/[0.04] px-5 py-4">
      <div className="flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-indigo-500/15">
        <Icon weight="bold" className="h-[18px] w-[18px] text-indigo-300" />
      </div>
      <span className="text-sm font-medium text-zinc-300">{item.label}</span>
    </div>
  );
}

function MarqueeRow({ items, reverse = false, duration = 34 }) {
  const reduce = useReducedMotion();
  const doubled = [...items, ...items];

  return (
    <div
      className="relative flex overflow-hidden"
      style={{
        maskImage: 'linear-gradient(90deg, transparent, black 10%, black 90%, transparent)',
        WebkitMaskImage: 'linear-gradient(90deg, transparent, black 10%, black 90%, transparent)',
      }}
    >
      <motion.div
        className="flex flex-none gap-4 py-2 pr-4"
        animate={reduce ? undefined : { x: reverse ? ['-50%', '0%'] : ['0%', '-50%'] }}
        transition={reduce ? undefined : { duration, repeat: Infinity, ease: 'linear' }}
      >
        {doubled.map((item, i) => (
          <UseCaseCard key={i} item={item} />
        ))}
      </motion.div>
    </div>
  );
}

export function UseCases() {
  return (
    <section className="py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="mb-4 text-center text-3xl font-bold text-zinc-100 md:text-4xl">Whatever you're chasing</h2>
        <p className="mx-auto mb-16 max-w-xl text-center text-lg text-zinc-400">
          If it needs a reply, we'll follow up on it.
        </p>
      </div>

      <div className="space-y-4">
        <MarqueeRow items={useCases} duration={36} />
        <MarqueeRow items={[...useCases].reverse()} reverse duration={42} />
      </div>
    </section>
  );
}
